<template>
  <NuxtLinkLocale
    :to="`/${currentGameSlug}/${slug}`"
    class="hot_category_card d-flex-row align-end"
    :class="[flex, currentGameSlug]"
    @mouseenter.native="handleArrowEvent('inside')"
    @mouseleave.native="handleArrowEvent('outside')"
  >
    <img
      :src="image"
      alt="hot_category_bg"
      class="hot_category_bg"
      loading="lazy"
      v-if="image"
    />
    <div class="d-flex-column category_info justify-start align-start gap-5">
      <div class="d-flex-row flex-1 space-between">
        <h4 class="t-white font-family-1 title-h4 f-w-600">
          {{ short_title }}
        </h4>
        <div
          class="arrow_right md-hide"
          ref="arrow_right"
          :class="[currentGameSlug]"
        >
          <h4
            class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
            ref="arrow_right_text"
          >
            {{ $t("main.buy_now") }}
          </h4>
          <arrow-right />
        </div>
      </div>

      <p class="regular-l font-family-2 t-white">
        {{ description }}
      </p>
      <div class="d-flex-row justify-start.flex-wrap gap-24">
        <ul class="perk_list" :class="[currentGameSlug]">
          <li
            class="t-white regular-m f-w-400 font-family-2 white-space-no"
            v-for="perk in perks"
          >
            {{ perk.title }}
          </li>
        </ul>
      </div>
    </div>
  </NuxtLinkLocale>
</template>

<script setup>
import { ref } from "vue";
import ArrowRight from "../icons/ArrowRight.vue";

const arrow_right = ref(null);
const arrow_right_text = ref(null);

const { image, short_title, description, perks, slug } = defineProps({
  image: {
    default: "",
  },
  short_title: {
    default: "",
  },
  description: {
    default: "",
  },
  perks: {
    default: [],
  },
  slug: {
    default: "",
  },
  currentGameSlug: {
    default: "",
  },
  flex: {
    default: "flex-5",
  },
});
const handleArrowEvent = (prompt) => {
  const el = arrow_right.value;
  const width = el?.getBoundingClientRect();
  const elText = arrow_right_text.value;
  const elWidth = elText?.getBoundingClientRect();
  if (prompt === "outside") {
    el.style.width = "36px";
  }
  if (prompt === "inside") {
    const calWidth = elWidth.width + width.width + 12;
    el.style.width = `${calWidth}px`;
  }
};
</script>
